/**
 * Date utility functions for consistent local timezone handling
 */

/**
 * Get today's date in YYYY-MM-DD format (local timezone)
 * This avoids the UTC conversion issue with toISOString()
 */
export const getLocalToday = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Get current date/time in ISO format but using local timezone
 */
export const getLocalISOString = () => {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60000;
  return new Date(now - offset).toISOString();
};

/**
 * Format a date to DD/MM/YYYY (Indian format)
 */
export const formatDateDDMMYYYY = (isoDate) => {
  if (!isoDate) return '';
  const parts = isoDate.split('-');
  if (parts.length === 3) {
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
  return isoDate;
};

/**
 * Format a date to YYYY-MM-DD from DD/MM/YYYY
 */
export const formatDateYYYYMMDD = (ddmmyyyy) => {
  if (!ddmmyyyy) return '';
  const parts = ddmmyyyy.split('/');
  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return ddmmyyyy;
};

/**
 * Get a date N years ago from today (for age calculations)
 */
export const getDateYearsAgo = (years) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - years);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
